import { render } from "./ListeLanguePage.vue?vue&type=template&id=30b48a24&ts=true"
import script from "./ListeLanguePage.vue?vue&type=script&lang=ts"
export * from "./ListeLanguePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__